/**
 * @prop --uui-filter-chip-color: color for filter chip in default state
 * @prop --uui-filter-chip-active-color: color for filter chip in active state
 * @prop --uui-filter-chip-active-color: color for filter chip in hover state
 **/

.uui-button-no-styles {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  font-size: var(--uui-default-font-size);
}

:host([readonly]) .uui-filter-button {
  display: none;
}

:host([readonly]) * {
  pointer-events: none;
}

:host {
  --uui-filter-chip-color: var(--uui-theme-core-500);
  --uui-filter-chip-active-color: var(--uui-theme-core-400);
  --uui-filter-chip-hover-color: var(--uui-theme-core-400);
  --uui-filter-chip-icon-color: var(--uui-theme-on-core-800);
  --uui-filter-chip-right-margin: 1.25em;
  --uui-filter-chip-bottom-margin: 0em;
  --uui-filter-chip-text-decoration: underline;
  --uui-filter-chip-max-width: none;
  --uui-filter-chip-more-max-width: none;
}

.uui-filter-chip-container {
  font-family: var(--uui-primary-font-family);
  color: var(--uui-filter-chip-color);
  font-size: var(--uui-default-font-size);
  line-height: var(--uui-extra-small-line-height);
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0.125em 0.875em;
}

.uui-filter-chip-margin {
  margin-right: var(--uui-filter-chip-right-margin);
  margin-bottom: var(--uui-filter-chip-bottom-margin);
  white-space: nowrap;
}

.uui-filter-button {
  white-space: nowrap;
  height: 44px;
}

.uui-filter-chip-large {
  justify-content: space-between;
  background-color: transparent;
  border: 0.0625em solid var(--uui-filter-chip-color);
  border-radius: 1.125em;
  min-width: 7.5em;
  height: 2.25em;
}

/*
    explicit styles for unselected large chip as the default border is 1px 
    and need to account for the border width changing on hover or active state
*/
.uui-filter-chip-large:not(.uui-filter-chip-selected, .uui-filter-chip-more):hover,
.uui-filter-chip-large:not(.uui-filter-chip-selected, .uui-filter-chip-more):active {
  padding: 0.3125em 0.8125em;
  border-width: 0.125em;
}

.uui-filter-chip-container svg {
  fill: var(--uui-filter-chip-color);
}

.uui-filter-chip-container:hover {
  border-color: var(--uui-filter-chip-hover-color);
  color: var(--uui-filter-chip-hover-color);
  text-decoration: var(--uui-filter-chip-text-decoration);
}

.uui-filter-chip-container:hover svg {
  fill: var(--uui-filter-chip-hover-color);
}

.uui-filter-chip-container:active {
  text-decoration: var(--uui-filter-chip-text-decoration);
}

.uui-filter-chip-container:active svg {
  fill: var(--uui-filter-chip-active-color);
}

.uui-filter-chip-icon-container {
  width: 1.5em;
  height: 1.5em;
  border: 0.063em solid var(--uui-filter-chip-color);
  border-radius: 1.5em;
  margin-right: 0.25em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.uui-filter-chip-container:hover .uui-filter-chip-icon-container {
  border-color: var(--uui-filter-chip-hover-color);
}

.uui-filter-chip-container:active .uui-filter-chip-icon-container {
  border-color: var(--uui-filter-chip-active-color);
}

.uui-filter-chip-small {
  padding: 0.125em 0.875em 0.125em 0;
}

.uui-filter-chip-small.uui-filter-chip-selected
  .uui-filter-chip-icon-container {
  background-color: var(--uui-filter-chip-active-color);
  border-color: transparent;
}

.uui-filter-chip-small.uui-filter-chip-selected
  .uui-filter-chip-icon-container
  svg {
  fill: var(--uui-filter-chip-icon-color);
}

.uui-filter-chip-small.uui-filter-chip-selected:hover
  .uui-filter-chip-icon-container {
  background-color: var(--uui-filter-chip-hover-color);
}

.uui-filter-chip-small.uui-filter-chip-selected:active
  .uui-filter-chip-icon-container {
  background-color: var(--uui-filter-chip-active-color);
}

.uui-filter-chip-container:active {
  border-color: var(--uui-filter-chip-active-color);
  color: var(--uui-filter-chip-active-color);
}

.uui-filter-chip-large svg {
  padding-left: 0.75em;
}

.uui-filter-chip-large.uui-filter-chip-selected {
  color: var(--uui-filter-chip-icon-color);
  border: transparent;
  background-color: var(--uui-filter-chip-active-color);
}

.uui-filter-chip-large.uui-filter-chip-selected svg {
  fill: var(--uui-filter-chip-icon-color);
}

.uui-filter-chip-large.uui-filter-chip-selected:hover {
  background-color: var(--uui-filter-chip-hover-color);
}

.uui-filter-chip-large.uui-filter-chip-selected:active {
  background-color: var(--uui-filter-chip-active-color);
}

.uui-filter-chip-large.uui-filter-chip-more {
  color: var(--uui-filter-chip-icon-color);
  padding-right: 0.5em;
  border: transparent;
  background-color: var(--uui-filter-chip-active-color);
}

.uui-filter-chip-more .uui-filter-button {
  margin-left: var(--uui-small-gap);
}

.uui-filter-button {
  max-width: var(--uui-filter-chip-max-width);
}

.uui-filter-chip-more {
  max-width: var(--uui-filter-chip-more-max-width);
}

.uui-filter-chip-large .bubble {
  border-radius: 0.92em;
  padding: 0.3em;
  font-size: 0.875em;
  font-weight: var(--uui-font-weight-normal);
  background-color: var(--uui-filter-chip-icon-color);
  color: var(--uui-filter-chip-active-color);
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 16px;
}

.content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  line-height: 1.5em;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
}
